<template>
  <div class="service-light-giveway">
    <radioButton
      :id="'givewayOption' + 'giveway'"
      title="贈品領取方式"
      :options="options_fare"
      v-model="info.givewayType"
      @input="changeFareType"
      :disabled="disabled"
      :errorText="errorText.givewayType"
    ></radioButton>

    <selectNumButton
      :id="'givewayName' + 'giveway'"
      :title="selectNumButtonTitle"
      v-model="selectGiveway"
      :countChange="countGiveway()"
      :disabled="disabled"
      :giftPoints="giftPoints"
      v-if="info.givewayType === 1 || info.givewayType === 2"
      :errorText="errorText.givewayName"
    >
    </selectNumButton>

    <div class="addrs-title-block" v-if="info.givewayType === 2">
      <div :class="['addrs-title', disabled ? 'addrs-title-disabled' : '']">
        贈品寄送地址
      </div>
      <checkbox
        :id="'givewayType' + 'giveway'"
        :options="options_addrs_fare"
        v-model="select_addrs_fare"
        :disabled="info.givewayType !== 2 || disabled"
      />
    </div>

    <addrsField
      :id="'givewayAddress' + 'giveway'"
      v-model="info.givewayAddress"
      :disabled="
        select_addrs_fare.length > 0 || info.givewayType !== 2 || disabled
      "
      :errorText="errorText.givewayAddress"
      v-if="info.givewayType === 2"
    />

    <div
      class="givewayTip"
      v-if="fare != null && fare != undefined && info.givewayType === 2"
    >
      運費 {{ fare }} 元
    </div>
  </div>
</template>

<script scoped>
import checkbox from 'Components/checkbox/checkboxGroup.vue';
import addrsField from 'Components/addr/addrsField.vue';
import radioButton from 'Components/button/radioButton.vue';
import selectNumButton from 'Components/button/selectNumButton.vue';
import store from 'Store/store';

export default {
  name: 'ServiceLightPersonInfo',
  components: {
    checkbox,
    addrsField,
    radioButton,
    selectNumButton,
  },
  data() {
    return {
      fare: store.state.main.onlineStatus.lightInfo.givewayFare,
      options_addrs_fare: [{ text: '同祈福人1', value: 'Y' }],
      options_fare: [
        { text: '不需要', value: 0 },
        { text: '現場領取', value: 1 },
        { text: '郵寄', value: 2 },
      ],
      select_addrs_fare: [],
      selectGiveway: {
        text: '',
        value: 0,
        count: 0,
      },
      selectValue: 0,
      errorText: {
        givewayAddress: {
          county: '',
          town: '',
          detail: '',
        },
        givewayName: '',
        givewayType: '',
      },
    };
  },
  watch: {
    select_addrs_fare: function() {
      this.copyFirstAddrsToFare();
    },
    'prayerInfo.address.county': function() {
      this.copyFirstAddrsToFare();
    },
    'prayerInfo.address.town': function() {
      this.copyFirstAddrsToFare();
    },
    'prayerInfo.address.detail': function() {
      this.copyFirstAddrsToFare();
    },
    lightsCount(newCount) {
      if (newCount - this.selectValue < 0) {
        this.resetGiveway();
      }
    }
  },
  beforeMount() {
    this.info = this.prayerInfo;

    this.resetGiveway();
  },
  props: {
    id: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    givewayInfo: {},
    prayerInfo: {},
    value: {},
    lightsCount: {},
  },
  methods: {
    resetGiveway() {
      this.selectGiveway = this.givewayInfo.map((giveway) => {
        return {
          text: giveway.text,
          value: giveway.value,
          count: 0,
        };
      });

      this.countGiveway();
    },
    countGiveway() {
      let value = 0;
      let givewayName = '';

      this.selectGiveway.forEach((select) => {
        if (select.count > 0) {
          value = value + select.count * select.value;
          if (givewayName.length != 0) {
            givewayName = givewayName + ', ';
          }
          givewayName = givewayName + select.text + ' x ' + select.count;
        }
      });

      this.updateGiveway(value, givewayName);
    },
    updateGiveway(selectValue, givewayName) {
      this.selectValue = selectValue;
      this.info.givewayName = givewayName;
      this.$emit('updateGiveway', {
        givewayName,
        givewayAddress: this.info.givewayAddress,
      });
    },
    changeFareType() {
      if (this.info.givewayType !== 2) {
        this.select_addrs_fare = [];
        this.info.givewayAddress.county = '';
        this.info.givewayAddress.town = '';
        this.info.givewayAddress.detail = '';
      }

      if (this.info.givewayType === 0) {
        this.info.givewayName = '';
      }
    },
    copyFirstAddrsToFare() {
      if (
        this.select_addrs_fare != null &&
        this.select_addrs_fare != undefined &&
        this.select_addrs_fare.length > 0
      ) {
        if (this.info.address != null && this.info.address != undefined) {
          Object.assign(this.info.givewayAddress, this.info.address);
        }
      }
    },
    checkError() {
      // 清空錯誤
      Object.keys(this.errorText)
        .filter((element) => element !== 'givewayAddress')
        .forEach((element) => (this.errorText[element] = ''));

      Object.keys(this.errorText)
        .filter((element) => element === 'givewayAddress')
        .forEach((element) =>
          Object.keys(this.errorText[element]).forEach(
            (errorAddress) => (this.errorText[element][errorAddress] = '')
          )
        );
      // 檢核欄位
      Object.keys(this.info)
        .filter(
          (element) =>
            false === (element === 'givewayName' && this.info.givewayType === 0)
        )
        .forEach((element) => {
          if (this.info[element] === '') {
            this.errorText[element] = '必填';
          }
        });

      if (this.info.givewayType === 2) {
        Object.keys(this.info.givewayAddress).forEach((element) => {
          if (this.info.givewayAddress[element] === '') {
            this.errorText.givewayAddress[element] = '必填';
          }
        });
      }

      if (this.selectValue > this.lightsCount) {
        this.errorText.givewayName = '請檢查贈品數量';
      }

      const givewayAddressValidateResult =
        this.info.givewayType !== 2 ||
        this.info.givewayAddress.detail.includes('號');
      if (false === givewayAddressValidateResult) {
        this.errorText.givewayAddress.detail = '格式錯誤';
      }

      const checkResult =
        Object.values(this.errorText).every(
          (element) =>
            element !== '必填' &&
            element !== '請檢查贈品數量' &&
            Object.values(element).every((subElement) => subElement !== '必填')
        ) && givewayAddressValidateResult;

      return { result: checkResult, errorText: this.errorText };
    },
  },
  computed: {
    giftPoints() {
      return (this.lightsCount || 0) - (this.selectValue || 0);
    },
    selectNumButtonTitle() {
      return `選擇贈品 (剩餘點數：${this.giftPoints} 點)`;
    }
  },
};
</script>

<style>
.info-title {
  color: black;
  font-weight: bold;
  font-size: 16px;
  margin-top: 50px;
  margin-bottom: 30px;
}
.title-disabled {
  color: #b18147;
}

.contact-block,
.contact-phone {
  width: 50%;
}

.addrs-title-block {
  height: 30px;
  display: flex;
  justify-content: space-between;
}

.addrs-title {
  color: #b18147;
  font-weight: bold;
  font-size: 12px;
  margin-top: 5px;
}

.addrs-title-block > div > div > div > .custom-control-inline {
  margin-right: 0;
}

.addrs-title-disabled {
  color: gray;
}
.line {
  margin-top: 30px;
  width: 100%;
  border-top: 1px solid;
  border-color: black;
}
.givewayTip {
  color: black;
  font-size: 16px;
}

.service-light-giveway .checkbox-title {
  font-size: 18px;
  margin: 10px 0;
}

@media (min-width: 768px) {
  .grid-container {
    display: grid;
    grid-template-columns: 50% 49%;
    grid-column-gap: 10px;
  }
  .birth-time {
    margin-top: 20px;
  }
}
</style>
